// angular
import { ActivatedRoute } from '@angular/router';
import { Component, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { SuppliersFiltersComponent } from './components/suppliers-filters/suppliers-filters.component';
import { CardsListComponent } from './components/cards-list/cards-list.component';
import { SolutionsPeopleBrowseComponent } from '@app/+solutions/components/solutions-people-browse/solutions-people-browse.component';

@Component({
  selector: 'pwj-suppliers-list',
  standalone: true,
  imports: [
    SuppliersFiltersComponent,
    CardsListComponent,
    SolutionsPeopleBrowseComponent,
    TranslateModule,
  ],
  templateUrl: './suppliers-list.component.html',
  styleUrl: './suppliers-list.component.scss',
})
export class SuppliersListComponent {
  public pageTitle = signal<string>('');

  private readonly _activatedRoute = inject(ActivatedRoute);

  private _currentPath = '';

  constructor() {
    this._currentPath = this._activatedRoute.snapshot.url?.[0]?.path ?? '';
    this._activatedRoute.data.subscribe(data => {
      this.pageTitle.set(data['titleKey'] ?? '');
    });
    this._activatedRoute.url.subscribe(url => {
      this._currentPath = url?.[0]?.path ?? '';
    });
  }

  get usePeopleProfiles(): boolean {
    return this._currentPath === 'suppliers';
  }
}
